import React, { useEffect, useRef, useState } from 'react'
import otpStyles from "./OtpInputs.module.css"

function OtpInputs({getOtp, resetTrigger}) {
    const otpLen = 6
    const [otp,setotp]=useState(new Array(otpLen).fill(''));
    const inputRef=useRef([]);
    useEffect(()=>{
      if(inputRef.current[0]){
          inputRef.current[0].focus();
      }
    },[])


    useEffect(() => {
      setotp(new Array(otpLen).fill(""));
    
      if (inputRef.current[0]) {
        inputRef.current[0].focus();
      }
    }, [resetTrigger])
    const handleChange=(i,e)=>{
      const value=e.target.value;
      if(isNaN(value)){
        return
      }
      const newOtp=[...otp];

      //allow only one input
      newOtp[i]=value.substring(value.length-1);
      setotp(newOtp);

      //submit
      const combinedOtp=newOtp.join("");

      if(combinedOtp.length===otpLen){
        getOtp(combinedOtp);
      }
      else{
        getOtp(null)
      }
      //Move to next input field
      if(value && i<otpLen-1 &&inputRef.current[i+1])
      {
        inputRef.current[i+1].focus();
      }
    };
    const handleClick=(i)=>{
      inputRef.current[i].setSelectionRange(1,1);
    }
    const handleKeyDown=(i,e)=>{
      //backspace function
      if(e.key==="Backspace" && !otp[i] && i>0 && inputRef.current[i-1]){
        inputRef.current[i-1].focus();
      }
    }
    const handlePaste=(e)=>{
      e.preventDefault();
      const pasteData=e.clipboardData.getData("text").trim()
      if (isNaN(pasteData)) return
      const pasteArray = pasteData.slice(0, otpLen).split("")
      const newOtp = [...otp]

      pasteArray.forEach((val, index) => {
        newOtp[index] = val;
      })
      setotp(newOtp)
      const combinedOtp = newOtp.join("")

      if (combinedOtp.length === otpLen) {
        getOtp(combinedOtp);
      } else {
        getOtp(null);
      }
      const lastIndex = pasteArray.length - 1;

      if (inputRef.current[lastIndex]) {
        inputRef.current[lastIndex].focus();
      }
    }
  return (
    <div>
        {otp.map((value,index)=>{
            return (
            <input
            key={index}
            type='text' value={value}
            ref={(input)=>(inputRef.current[index]=input)}
            onChange={(e)=>handleChange(index,e)}
            onClick={()=>{handleClick(index)}}
            onKeyDown={(e)=>{handleKeyDown(index,e)}}
            className={otpStyles.otpInput}
            placeholder='-'
            onPaste={handlePaste}
            />
            );
          })}
    </div>
  )
}

export default OtpInputs;